export default "__VITE_ASSET__BPCslwRd__"